import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const AssignSalesRegionForm = (props) => {
  const frmRef = useRef({});
  const [regions, setRegions] = useState();
  const [employeeData, setEmployeeData] = useState();
  const [filteredEmployees, setFilteredEmployees] = useState("");
  const [resionData, setResionData] = useState("");

  const { sendRequest: getAssignResion } = useHttp();

  useEffect(() => {
    getAssignResion(
      {
        url: `/api/assignRegion/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        const sortedData = data.sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });
        setResionData(sortedData);
      }
    );
  }, [getAssignResion]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?useCase=Sales&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("emp", data.output);
        //setEmployeeData(data.output);

        var i = 0;

        var tempempdata = data.output;
        var newempList = [];

        do {
          newempList = newempList.concat({
            userId: tempempdata[i].userId,

            useCase: tempempdata[i].useCase,
            empId: tempempdata[i].empId,
            employeeName: tempempdata[i].employeeName,

            regionId: tempempdata[i].regionId,
          });
          i++;
        } while (data.output.length > i);

        //console.log("newempList", newempList);

        setEmployeeData(newempList);
      }
    );
  }, [getEmp]);

  const handleRegionChange = (event, i) => {
    // //console.log(i);
    const selectedRegionId = event.target.value;
    event.preventDefault(false);
    // const updatedEmployeeData = employeeData.map((employee,i) => {
    //   return {
    //     ...employee,
    //    regionId: selectedRegionId,
    //   };
    // });

    const updatedEmployeeData = [...employeeData];
    updatedEmployeeData[i] = {
      ...updatedEmployeeData[i],
      regionId: selectedRegionId,
    };

    setEmployeeData(updatedEmployeeData);

    //console.log(updatedEmployeeData);
  };

  const { sendRequest: postRegion } = useHttp();

  const submitRegionHandler = (e) => {
    e.preventDefault();
    const data = {
      regionName: frmRef.current.region_name.value,
      orgId: parseInt(localStorage.getItem("orgId")),
      status: 1,
      regionType: "Sales",
      createdDate: moment(new Date().toISOString().slice(0, 10)).format(
        "DD/MM/YYYY"
      ),
      createdBy: parseInt(localStorage.getItem("id")),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
    };

    //console.log(data);

    postRegion(
      {
        url: "/api/region/",
        method: "POST",
        body: data,
      },
      (res) => {
        toast.success(`Region Added`);
        getRegion(
          {
            url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
          },
          (data) => {
            //console.log("region", data);
            setRegions(data);
          }
        );
      }
    );
  };

  const { sendRequest: getRegion } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?regionType=Sales&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);
        setRegions(data);
      }
    );
  }, [getRegion]);

  const { sendRequest: PostAssignRegion } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    const promises =
      employeeData &&
      employeeData.map((emp) => {
        const data = {
          discountApprovalDate: moment(
            new Date().toISOString().slice(0, 10)
          ).format("DD/MM/YYYY"),

          procurementOfficerId: emp.empId,
          assignRegionDate: moment(
            new Date().toISOString().slice(0, 10)
          ).format("DD/MM/YYYY"),
          regionId: emp.regionId,
          createdDate: moment(new Date().toISOString().slice(0, 10)).format(
            "DD/MM/YYYY"
          ),
          status: 1,
          orgId: parseInt(localStorage.getItem("orgId")),
          createdBy: parseInt(localStorage.getItem("id")),
          warehouseId: parseInt(localStorage.getItem("warehouseId")),
        };

        if (props.update.procurmentTargetId) {
          data["assignRegionId"] = props.update.assignRegionId;
        }

        //console.log(data);

        //     return PostAssignRegion({
        //       url: "/api/assignRegion/",
        //       method:props.update.assignRegionId? "PUT":"POST",

        //       body: data,
        //     });
        //   });

        //   Promise.all(promises).then(() => {

        //  //   toast.success("target Set")

        //    toast.success(`Assign  ${props.update ? "Updated" : "Assign"}`);
        //    props.addForm(false)
        //   });
        // };

        const existingRecord =
          resionData &&
          resionData.find(
            (target) => target.procurementOfficerId === emp.empId
          );
        if (existingRecord) {
          //console.log(existingRecord);
          const dropdown = document.getElementById("region-dropdown");
          const empId = existingRecord.empId;
          const newRegionId = data.regionId;
          const employee = employeeData.find((emp) => emp.empId === empId);
          if (employee) {
            employee.dropdown.value = newRegionId;
          }

          return Promise.all([
            PostAssignRegion({
              url: `/api/assignRegion/`,
              method: "PUT",
              body: { ...existingRecord, status: 0 },
            }),
            PostAssignRegion({
              url: "/api/assignRegion/",
              method: "POST",
              body: data,
            }),
          ]);
        } else {
          return PostAssignRegion({
            url: "/api/assignRegion/",
            method: props.update.discountApprovalId ? "PUT" : "POST",
            body: data,
          });
        }
      });

    Promise.all(promises)
      .then(() => {
        toast.success(`Region  ${props.update ? "Updated" : "Added"}`);
        //  props.addForm(false);
      })
      .catch((error) => {
        toast.error(`Error: ${error.message}`);
      });
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Region Allocation </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Procurement Officer Name</th>
                          <th>Region </th>
                        </tr>
                      </thead>
                      <tbody>
                        {employeeData &&
                          employeeData.map((employee, i) => (
                            <tr key={i}>
                              <td>{employee.employeeName}</td>
                              <td>
                                {" "}
                                <select
                                  required
                                  id="region-dropdown"
                                  className="inputs dropdowns "
                                  ref={(el) =>
                                    (frmRef.current["set_region"] = el)
                                  }
                                  autoComplete="off"
                                  value={employee.regionId}
                                  onChange={(event) =>
                                    handleRegionChange(event, i)
                                  }
                                >
                                  <option value="">select</option>
                                  {regions &&
                                    regions.map((region) => (
                                      <option
                                        key={region}
                                        value={region.regionId}
                                      >
                                        {region.regionName}
                                      </option>
                                    ))}
                                </select>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default AssignSalesRegionForm;
